<template>
  <div class="container">
    <slot></slot>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";

@Component
export default class MobilePage extends Vue {}
</script>

<style>
body {
  background-color: #f3f3f3;
}
</style>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: white;
  padding-bottom: 45px;
}

@media (min-width: 480px) {
  /* smartphones, Android phones, landscape iPhone */
  .container {
    width: 480px;
    margin-left: auto;
    margin-right: auto;
    border-left: 1px solid #ededed;
    border-right: 1px solid #ededed;
  }
}
</style>
